import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { ErrorBoundaryFallbackProps as FallbackProps } from 'dibs-error-tools/ErrorBoundary';
import styles from './Error500Layout.scss';

const errorImgSrc = 'https://a.1stdibscdn.com/dist/adhoc/wristwatch.jpg';

const Error500Layout: FC<FallbackProps> = ({ error }) => {
    const messageLink = (
        <a href="" title="reload current page">
            <FormattedMessage
                id="dbl.Error500Layout.messageLink"
                defaultMessage="try loading this page again"
            />
        </a>
    );

    const unkownError = (
        <FormattedMessage
            id="dbl.Error500Layout.unknownError"
            defaultMessage="An unknown or server error occurred."
        />
    );

    const errMsg = (error && error.message) || unkownError;

    return (
        <div className={styles.container}>
            <div className={styles.info}>
                <h3 className={styles.header}>
                    <FormattedMessage
                        id="dbl.Error500Layout.title"
                        defaultMessage="Sorry, we're currently experiencing technical difficulties."
                    />
                </h3>
                <p>
                    <FormattedMessage
                        id="dbl.Error500Layout.message"
                        defaultMessage="We know your time is valuable. Give us a few seconds and {messageLink}."
                        values={{ messageLink }}
                    />
                </p>
                <details>
                    <summary>
                        <FormattedMessage
                            id="dbl.Error500Layout.detailSummary"
                            defaultMessage="An error occurred."
                        />
                    </summary>
                    <FormattedMessage
                        id="dbl.Error500Layout.printError"
                        defaultMessage="Error: {errMsg}."
                        values={{ errMsg }}
                    />
                </details>
            </div>
            <div className={styles.imageWrap}>
                <img className={styles.image} src={errorImgSrc} alt="wristwatch" />
            </div>
        </div>
    );
};

export default Error500Layout;
